export default {
  title: '登录 / 注册',
  subtitle: '手机 / 邮箱验证即登录，新用户自动创建账号',
  tabUsername: '用户名',
  tabEmail: '邮箱',
  tabPhone: '手机号',
  usernamePlaceholder: '请输入用户名',
  emailPlaceholder: '请输入邮箱',
  phonePlaceholder: '请输入手机号',
  passwordLabel: '密码',
  passwordPlaceholder: '请输入密码',
  verifyCode: '验证码',
  emailCodePlaceholder: '邮箱验证码',
  smsCodePlaceholder: '短信验证码',
  getCode: '获取验证码',
  rememberMe: '记住我',
  forgotPassword: '忘记密码?',
  submit: '登录 / 注册',
  loading: '登录中...',
  loginSuccess: '登录成功，正在进入...',
  quickLogin: '快捷登录 / 注册',
  socialUnavailable: '该登录方式暂未开放',
  metamaskNotInstalled: '未检测到 MetaMask，请先安装钱包插件',
  metamaskRejected: '已取消钱包授权 / 签名',
  metamaskConnectFailed: '钱包连接失败，请重试',
  metamaskRequestPending: '请在 MetaMask 弹窗中确认授权，或取消后重试',
  metamaskAccountChanged: '钱包账号已切换，请重新发起登录',
  metamaskRateLimited: '操作太频繁，请稍后再试',
  metamaskBanned: '账号已被禁用，请联系客服',
  agreementPrefix: '登录即代表同意',
  userAgreement: '《用户协议》',
  and: '与',
  privacyPolicy: '《隐私政策》',
  agreementSuffix: '，且已满18周岁',
  forgotTitle: '找回登录密码',
  forgotSubtitle: '仅用户名账号需找回;先验证已绑定的手机 / 邮箱',
  accountLabel: '账号(用户名)',
  accountPlaceholder: '输入注册用户名',
  boundContactLabel: '已绑定手机 / 邮箱',
  boundContactPlaceholder: '输入绑定的手机号（含区号，如 +86）或邮箱',
  sixDigitCodePlaceholder: '6 位验证码',
  nextStep: '下一步',
  newPasswordLabel: '新登录密码',
  newPasswordPlaceholder: '8-64 位,含字母与数字',
  confirmPasswordLabel: '确认新密码',
  confirmPasswordPlaceholder: '再次输入新密码',
  confirmReset: '确认重置',
  resetSuccess: '密码重设成功，请重新登录',
  rememberedText: '想起来了?',
  backToLogin: '返回登录',
  errorUsernameRequired: '请输入用户名',
  errorUsernameInvalid: '用户名需为 4-20 位字母、数字或下划线',
  errorPasswordLetterDigit: '密码必须同时包含字母和数字',
  errorEmailInvalid: '请输入正确的邮箱地址',
  errorEmailCodeRequired: '请输入 6 位邮箱验证码(错误示例:验证码不正确)',
  errorPhoneInvalid: '请输入正确的手机号',
  errorPhoneCodeRequired: '请输入 6 位短信验证码',
  errorPasswordRequired: '请输入密码',
  errorPasswordLength: '密码长度需为 8-64 位',
  errorPasswordTooShort: '密码至少 6 位',
  errorAgreementRequired: '请同意用户协议',
  errorContactRequired: '请输入正确的绑定手机号（含区号）或邮箱',
  errorLoginFailed: '登录失败，请稍后重试',
  errorNetwork: '网络连接失败，请检查网络后重试',
  errorNewPasswordRequired: '新密码须为 8–64 位且含字母与数字',
  errorNewPasswordInvalid: '密码需为 8-64 位，含字母与数字',
  errorConfirmPasswordMismatch: '两次输入的密码不一致',
  errorResetFailed: '重置密码失败，请稍后重试',
  codeSendLimited: '验证码发送次数已达上限，请 10 分钟后再试',
}
